const USER_TOKEN = 'user_token';

export const getToken = () => window.localStorage.getItem(USER_TOKEN) || '';

export const setToken = (token) =>
  window.localStorage.setItem(USER_TOKEN, token);

export const deleteToken = () => window.localStorage.removeItem(USER_TOKEN);
